import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';

interface EmptySlotProps {
  index: number;
  isOver: boolean;
  onClick: () => void;
}

/**
 * EmptySlot component for displaying an empty player slot
 * Used in GameSetupPlayers and PlayerComponent
 */
const EmptySlot = React.forwardRef<HTMLDivElement, EmptySlotProps>(({ index, isOver, onClick }, ref) => {
  const { t } = useTranslation();

  return (
    <div
      ref={ref}
      className={`flex flex-col items-center ${isOver ? 'bg-gray-200 bg-opacity-30 rounded-xl' : ''}`}
      style={{ minHeight: '150px' }}
      data-droppable="true"
      data-slot-index={index}
    >
      <div className="w-full mb-2">
        <IonButton
          onClick={onClick}
          fill='clear'
          expand="block"
          className="border-dashed border-2 flex flex-col w-full aspect-square rounded-xl items-center justify-center"
        >
          <IonIcon icon={addOutline} className="size-10 text-gray-400" />
        </IonButton>
      </div>
      <div className="text-center text-xs text-gray-400">{t('add_player')}</div>
    </div>
  );
});

export default EmptySlot;
